// @ts-check
import React from "react"
import Badge from "../atoms/Badge.atom"
import { generateRandomNumber } from "../../utils/numbers.utils"
import Tooltip from "../atoms/Tooltip.atom"
import PencilFillIcon from "../../design/assests/images/icons/pencil-fill"

export const TASK_ADMIN_INTERACTION_CHIP_TYPE = Object.freeze({
  CREATION: "created",
  EDITION: "updated",
})

/**
 * @type {React.FC<import("./TaskAdminInteractionChip.molecule.types.d").TaskAdminInteractionChipProps>}
 */
const TaskAdminInteractionChip = ({
  visible = true,
  iconClassName = "",
  badgeClassName = "",
  badgeProps = {},
  tooltipConfig = {
    className: "task-admin-interaction-chip-tooltip",
    position: "bottom",
  },
  tooltipValue = "",
  state = TASK_ADMIN_INTERACTION_CHIP_TYPE.CREATION,
  name = "",
}) => {
  const id = generateRandomNumber()
  const elementClassName = `bookmark-chip-${id}`
  if (!visible) return null
  const renderTooltipValue = () => {
    switch (state) {
      case TASK_ADMIN_INTERACTION_CHIP_TYPE.CREATION:
        return `Esta tarea fue creada por ${name}`
      case TASK_ADMIN_INTERACTION_CHIP_TYPE.EDITION:
        return `Esta tarea fue editada por ${name}`
      default:
        return tooltipValue
    }
  }
  const renderChipIcon = () => {
    switch (state) {
      case TASK_ADMIN_INTERACTION_CHIP_TYPE.CREATION:
        return <i className={`${iconClassName} pi pi-bookmark-fill`} />
      case TASK_ADMIN_INTERACTION_CHIP_TYPE.EDITION:
        return (
          <PencilFillIcon
            style={{
              color:
                "light-dark(var(--surface-highlight__light), var(--surface-shadow__dark))",
            }}
          />
        )
      default:
        return <i className={`${iconClassName} pi pi-bookmark-fill`} />
    }
  }
  return (
    <>
      <Badge
        className={`bookmark-chip ${elementClassName} ${badgeClassName}`}
        value={renderChipIcon()}
        {...badgeProps}
      />
      <Tooltip target={`.${elementClassName}`} {...tooltipConfig}>
        {renderTooltipValue()}
      </Tooltip>
    </>
  )
}

export default TaskAdminInteractionChip
